export const isZipCode = (slug: string): boolean => {
  const regEx: RegExp = /^\d{5}.*$/;
  return regEx.test(slug);
}
